import { _validationIssueTypes, useCleanData } from 'global/cnr/contexts/useHelpers/useCleanData'
import { convertHelpers } from 'global/common/convert'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import React, { useContext, useMemo } from 'react'
import { Icon, Label } from 'semantic-ui-react'
import { PopupSelect } from '../popups/PopupSelect'
import { _appDataOptionTypes } from 'global/viewSettings/data/AppDataSidebar'
import { ParentContext } from 'global/cnr/contexts/ParentContext'

const ImsAppData = ({
  appDataDocuments,
  activeItem,
  currentKey,
  handleClick_item,
  handleClick_popup,
  setCurrentVds,
  handle_showConfirmation
}) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { eventInfo_state } = states ?? {}
  const { appDataLinks } = eventInfo_state ?? {}

  const { validateAppData } = useCleanData()

  const appDataKeys = _.keys(appDataDocuments)

  const appDataDocument = useMemo(() => {
    if (!currentKey === 'appData') return null;
    const _appDataDocument = appDataDocuments?.[currentKey]
    return _appDataDocument
  }, [currentKey])

  const appDataValidations = useMemo(() => {
    return validateAppData({ appDataDocuments })
  }, [appDataDocuments])

  const filterVlds = (itemKey) => {

    const adv = appDataValidations?.[currentKey]
    const { issueGroups } = adv ?? {}

    const validation = {
      issueGroups: null,
      _summary: null,
      isValid: true,
      issueCount: 0,
      issueTypeCount: 0,
      dups: null
    }

    const _summary = {}

    if (_.isEmpty(issueGroups)) return;
    const _issueGroups = {}

    _.forEach(issueGroups, (issueItem, issueItemKey) => {
      const rez = _.find(issueItem, { appDataKey: currentKey, appDataItemKey: itemKey })
      if (rez) {
        _issueGroups[issueItemKey] = rez
        _summary[issueItemKey] = 1
      }
    })

    if (!_.isEmpty(_issueGroups)) {
      validation.issueGroups = _issueGroups
      validation._summary = _summary
      validation.isValid = false
      validation.issueTypeCount = _.size(_issueGroups)
    }

    return validation
  }

  const fnAltContent = (item) => {

    let selections = [];

    const vds = {
      docValidations: {},
      validations: {},
      showValidations: false,
      data: {},
      appDoc: null,
      appDocKey: null,
      hasDataLink: false,
      title: ''
    }

    switch (currentKey) {
      case 'appData':
        selections = { openPage: { key: 'openPage', icon: 'file alternate outline', iconColor: 'blue' } }
        const _appDataDocument = appDataDocuments?.[item?.key]
        vds.data = _appDataDocument
        vds.docValidations = appDataValidations?.[item?.key]
        vds.validations = appDataValidations?.[item?.key]
        vds.showValidations = true
        vds.title = vds.validations?._summary ? JSON.stringify(vds.validations?._summary, true, 2) : ''
        vds.appDoc = item?.key
        vds.hasDataLink = appDataLinks?.[item?.key]
        break;
      default:
        const _appDataItemDocument = appDataDocuments?.[currentKey]?.[item.key]
        vds.data = _appDataItemDocument
        vds.docValidations = appDataValidations?.[currentKey]
        vds.validations = filterVlds(item.key)
        vds.showValidations = true
        vds.appDoc = currentKey
        vds.appDocKey = item.key
        vds.hasDataLink = appDataLinks?.[currentKey]?.[item?.key]
        selections = { openPageItem: { icon: 'file alternate outline', iconColor: 'blue' } }
    }


    convertHelpers.createItemKeys(selections)

    // if (item?.key === 'sessions') {
    //   console.group('vds', item?.key)
    //   console.log('vds', vds)
    //   console.log('_summary', vds?.validations?._summary)
    //   console.log('selections', selections)
    //   console.groupEnd()
    // }

    if (_.isEmpty(selections)) { return; }

    const cb = (selectedItem) => handleClick_popup(item, selectedItem, selections)

    const lbls_validationSummary = (vds) => {
      const color = (sik) => {
        switch (sik) {
          case _validationIssueTypes.emptyObject:
            return 'grey'
          case _validationIssueTypes.duplicateArrayItems:
            return 'purple'
          case _validationIssueTypes.emptyString:
            return 'violet'
          case _validationIssueTypes.emptyArray:
            return 'orange'
          case _validationIssueTypes.invalidNumber:
            return 'teal'
          case _validationIssueTypes.duplicateItems:
            return 'brown'
          case _validationIssueTypes.missingArrayKeys:
            return 'pink'
          default:
            return 'yellow'
        }
      }


      const lbls = _.map(vds?.validations?._summary, (si, sik) => (
        <Label
          size='mini'
          circular
          color={color(sik)}
          title={_.startCase(sik)}
          onClick={(e) => { handleShow_validations(e, sik, vds) }}>
          {si}
        </Label>
      ))
      return <div style={{ display: 'flex', columnGap: '.5em', alignItems: 'center', marginRight: '.5em' }}>
        {lbls}
      </div>
    }

    const icon_summary = () => <div style={{ marginRight: '.25em' }}>
      <Icon name={'check circle outline'} color={'green'} title={'No Issues'} />
    </div>

    const icon_dataLink = () => <div style={{ marginRight: '.25em' }}>
      <Icon name={'linkify'} color={'grey'} title={'Has Data Links'} />
    </div>

    const handleShow_validations = (e, sik, _vds) => {
      e.stopPropagation()
      switch (sik) {
        case _validationIssueTypes.emptyObject:
          return;
        default:
        // nothing
      }

      const dataUpdates = {}
      const _dataUpdates = {}

      _.forEach(_vds?.docValidations?.issues, issue => {
        dataUpdates[issue.updateDataKey] = issue.updateDataValue
      })

      const _ig = _vds?.validations?.issueGroups?.[sik]

      _.forEach(_vds?.docValidations?.issueGroups, (issueGroup, issueGroupKey) => {
        _.forEach(issueGroup, (issueGroupItem) => {

          if (!_dataUpdates[issueGroupItem.appDataItemKey]) { _dataUpdates[issueGroupItem.appDataItemKey] = [] }


          switch (issueGroupKey) {
            case _validationIssueTypes.duplicateArrayItems:
              _dataUpdates[issueGroupItem.appDataItemKey].push({
                path: issueGroupItem.path,
                updateDataValue: issueGroupItem.updateDataValue,
                updateType: issueGroupKey,
                itemProp: issueGroupItem.itemProp,
                value: issueGroupItem.value,
              })
              break;

            case _validationIssueTypes.emptyArray:
            case _validationIssueTypes.emptyObject:
            case _validationIssueTypes.emptyString:
              _dataUpdates[issueGroupItem.appDataItemKey].push({
                path: issueGroupItem.path,
                remove: true,
                updateType: issueGroupKey,
                itemProp: issueGroupItem.itemProp,
                value: issueGroupItem.value,
              })
              break;

            case _validationIssueTypes.duplicateItems:
              _dataUpdates[issueGroupItem.appDataItemKey].push({
                path: issueGroupItem.path,
                remove: true,
                updateType: issueGroupKey,
                itemProp: issueGroupItem.itemProp,
                dups: issueGroupItem.dups,
                value: issueGroupItem.value,
              })
              break;

            case _validationIssueTypes.missingArrayKeys:
              _dataUpdates[issueGroupItem.appDataItemKey].push({
                path: issueGroupItem.path,
                updateType: issueGroupKey,
                itemProp: issueGroupItem.itemProp,
                rfz: issueGroupItem.rfz,
                value: issueGroupItem.value,
              })

          }
        })
      })

      console.groupEnd()

      _vds.dataUpdates = dataUpdates
      _vds._dataUpdates = _dataUpdates
      setCurrentVds && setCurrentVds(_vds)
      handle_showConfirmation && handle_showConfirmation({ optionType: _appDataOptionTypes.updateDataIssues })
    }

    return <div style={{ display: 'flex', columnGap: '.5em', alignItems: 'center' }}>
      {vds.hasDataLink && icon_dataLink()}
      {vds.showValidations && vds.validations?.issueTypeCount > 0 && lbls_validationSummary(vds)}
      {vds.showValidations && vds.validations?.issueTypeCount === 0 && icon_summary()}
      {handleClick_popup && <div><PopupSelect items={selections} dataItem={item} handleMenuAction={cb} icon={'ellipsis vertical'} /></div>}
    </div>
  }

  const items_all = (_keys) => {
    return _.map(_keys, (value) => {
      return {
        text: _.startCase(value),
        key: value,
        count: appDataDocuments && appDataDocuments[value] ? Object.keys(appDataDocuments[value]).length : 0
      }
    })
  }

  const item_selected = () => {
    const _itemz = []
    _.forEach(appDataDocument, (appData) => {
      const { _itemKey, name, lastName, firstName, startDate, startTime } = appData
      const hasSubtext = startDate
      _itemz.push({
        text: lastName ? `${lastName}, ${firstName}` : name,
        subText: hasSubtext ? `${startDate} - ${startTime}` : null,
        key: _itemKey,
        _itemKey: _itemKey,
        name: name
      })
    })
    return _.orderBy(_itemz, ['text'])
  }

  const itemSquares_allData = () => {
    if (appDataKeys) {
      const ims_pages = <ItemMenuSquares
        activeItem={activeItem}
        fn_altContent={fnAltContent}
        imsType={_imsTypes.inline}
        menuItems={items_all(appDataKeys)}
        onClick={handleClick_item}
      />
      return ims_pages
    }
  }

  const itemSquares_itemData = () => {
    if (appDataDocument) {
      const ims_pages = <ItemMenuSquares
        activeItem={activeItem}
        fn_altContent={fnAltContent}
        imsType={_imsTypes.inline}
        menuItems={item_selected()}
        onClick={handleClick_item}
      />
      return ims_pages
    }
  }

  return (
    currentKey === 'appData' ? itemSquares_allData() : itemSquares_itemData()
  )
}

export default ImsAppData